import React from 'react'

export const IconSucess = () => (
  <svg
    width="68"
    height="68"
    viewBox="0 0 68 68"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34 0.666687C15.6 0.666687 0.666626 15.6 0.666626 34C0.666626 52.4 15.6 67.3334 34 67.3334C52.4 67.3334 67.3333 52.4 67.3333 34C67.3333 15.6 52.4 0.666687 34 0.666687ZM34 60.6667C19.3 60.6667 7.33329 48.7 7.33329 34C7.33329 19.3 19.3 7.33335 34 7.33335C48.7 7.33335 60.6666 19.3 60.6666 34C60.6666 48.7 48.7 60.6667 34 60.6667ZM49.3 19.2667L27.3333 41.2334L18.7 32.6334L14 37.3334L27.3333 50.6667L54 24L49.3 19.2667Z"
      fill="var(--flora--colors-success-standard)"
    />
  </svg>
)
